import pathOr from 'ramda/src/pathOr'
import always from 'ramda/src/always'
import filter from 'ramda/src/filter'
import moduleDescriptions from 'root/src/shared/descriptions/modules'

export default (state, { moduleId, moduleKey, asyncOptionsStoreKey }) => {
	const options = pathOr([], ['form', moduleId, 'dropdownAsyncOptions', asyncOptionsStoreKey], state)
	const optionsFilter = pathOr(() => always(true), [moduleId, 'dropdownFilter'], moduleDescriptions)
	return filter(optionsFilter(state, { moduleKey }), options)
}
